import { QuizPlayerControlsProps as QuizControlsProps } from './types';
import { useTranslation } from '@/hooks/use-translation';
import { Button as BaseButton, ButtonProps } from '@/components/button';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/utils';

type QuizPlayerControlsProps = React.ComponentProps<'div'> &
  QuizControlsProps & {
    slots?: { Button?: React.ElementType<ButtonProps> };
    slotProps?: { button?: ButtonProps };
  };

export function QuizPlayerControls({
  onCancel,
  onConfirm = () => {},
  onNext,
  selectedAnswer,
  isAnswerValidated,
  isLastQuestion,
  requireConfirm,
  className,
  slots = {},
  slotProps,
  ...others
}: QuizPlayerControlsProps) {
  const { Button = BaseButton } = slots;
  const { t } = useTranslation();

  const getButtonText = () => {
    if (!isAnswerValidated && requireConfirm) return t('confirm', 'Conferma');
    if (isLastQuestion) return t('end', 'Fine');
    return t('next', 'Next');
  };

  const getButtonIcon = () => {
    if (!isAnswerValidated && requireConfirm) return null;
    if (isLastQuestion) return null;
    return <ArrowRight />;
  };

  const getButtonAction = () => {
    if (!isAnswerValidated && requireConfirm) return onConfirm;
    return onNext;
  };

  return (
    <div {...others} className={cn('mm:flex mm:justify-end', className)}>
      {(selectedAnswer || isAnswerValidated) && (
        <Button
          variant="brand"
          {...slotProps?.button}
          size="lg"
          onClick={getButtonAction()}
          endIcon={getButtonIcon()}
        >
          {getButtonText()}
        </Button>
      )}
    </div>
  );
}

QuizPlayerControls.displayName = 'QuizPlayerControls';
